module.exports = __webpack_public_path__ + "img/组件3.e8496462.png";